import React from 'react';
import { selectStyles } from '../../utils';
import { MdSearch, MdRefresh } from "react-icons/md";
import AsyncSearchSelect from '../common/AsyncSearchSelect';

export default function ApplicationsFiltersBar({
    draftFilters,
    setDraftFilters,
    fetchOrganizationOptions,
    onSearch,
    onReset,
}) {

    return (
        <div className="list-page-filter-bar">
            <div className="list-page-filter-fields row g-3 align-items-end">
                <div className="list-page-filter-field col-12 col-lg-4">
                    <div style={{ minWidth: 0, width: '100%' }}>
                        <AsyncSearchSelect
                            inputId="apps-filter-organization"
                            instanceId="apps-filter-organization"
                            classNamePrefix="ns-apps-org"
                            isClearable
                            placeholder="Organization — type to search"
                            aria-label="Organization"
                            fetchOptions={fetchOrganizationOptions}
                            value={draftFilters.organizationId ?? null}
                            onChange={(opt) =>
                                setDraftFilters((d) => ({
                                    ...d,
                                    organizationId: opt?.value ?? null,
                                }))
                            }
                            styles={selectStyles}
                        />
                    </div>
                </div>
                <div className="list-page-filter-field col-12 col-lg-4">
                    <label className="form-label visually-hidden" htmlFor="apps-filter-app-name">
                        App name
                    </label>
                    <input
                        id="apps-filter-app-name"
                        type="text"
                        className="form-control"
                        placeholder="App name"
                        autoComplete="off"
                        value={draftFilters.search ?? ''}
                        onChange={(e) =>
                            setDraftFilters((d) => ({ ...d, search: e.target.value }))
                        }
                    />
                </div>
                <div className="list-page-filter-field list-page-filter-actions col-12 col-lg-4">
                    <div className="add_app">
                        <button type="button" className="add_app_btn btn_theme_primary" title="Apply filters" onClick={onSearch}>
                            <MdSearch />
                            <span>Search</span>
                        </button>
                        <button type="button" className="add_app_btn_secondary btn_theme_secondary" title="Reset filters" onClick={onReset}>
                            <MdRefresh />
                            <span>Reset</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
